import apiUrl from "api-url";

import buildFetchDuck from "vendor/signal-utils/build-fetch-duck";
import chainReducers from "vendor/signal-utils/chain-reducers";
import {
  packageDetailsWithFilteredExceptions,
  sortedExceptionCounts,
} from "pages/partview/utils/exceptions.utils";

const STORE_MOUNT_POINT = "partViewDashboard";

//Ducks
const exceptionsListFetchDuck = buildFetchDuck(
  STORE_MOUNT_POINT,
  "exceptionsList",
  {},
);
const exceptionCountsFetchDuck = buildFetchDuck(
  STORE_MOUNT_POINT,
  "exceptionCounts",
  {},
);

const watchedTableDuck = buildFetchDuck(STORE_MOUNT_POINT, "watchedTable", {});

// Actions
const getScopedActionName = (actionName) =>
  `${STORE_MOUNT_POINT}/${actionName}`;
const SET_WATCHED_TABLE_PAGE_INDEX = getScopedActionName(
  "SET_WATCHED_TABLE_PAGE_INDEX",
);

// Action Creators
function fetchExceptionList() {
  return (dispatch) => {
    const url = apiUrl("partview/app/exception-type/list");
    return dispatch(
      exceptionsListFetchDuck.fetch(url, {}, sortedExceptionCounts),
    );
  };
}

function fetchExceptionOrPackageStatusCounts(
  fvOrgId = null,
  deliveryDateTo = undefined,
  deliveryDateFrom = undefined,
) {
  let toDate = "";
  let fromDate = "";
  if (deliveryDateTo) {
    toDate = `deliveryDateTo=${deliveryDateTo}`;
    if (!deliveryDateFrom) {
      toDate = `?${toDate}`;
    }
  }
  if (deliveryDateFrom) {
    fromDate = `?deliveryDateFrom=${deliveryDateFrom}`;
    if (toDate !== "") {
      fromDate = `${fromDate}&`;
    }
  }
  return (dispatch) => {
    const url = apiUrl(`/partview/app/dashboard/counts${fromDate}${toDate}`);
    const config = {
      headers: {
        Accept: `application/json;version=TOTAL_COUNT`,
      },
      params: {
        fvOrgId,
      },
    };
    return dispatch(exceptionCountsFetchDuck.fetch(url, config));
  };
}

function fetchWatchedPackages(hasDealerView = false, fvOrgId = null) {
  return (dispatch, getState) => {
    const state = getState();
    const url = apiUrl("/partview/app/search");
    const params = {
      watched: true,
      fvOrgId: fvOrgId,
      pageNumber: getWatchedTablePageIndex(state),
      pageSize: getWatchedTablePageSize(state),
      status: "active",
    };

    const transform = (data) => {
      let packageDetails = data?.data;
      if (hasDealerView) {
        packageDetails = data?.data?.map((result) => {
          return packageDetailsWithFilteredExceptions(result);
        });
      }

      return { ...data, data: packageDetails };
    };

    dispatch(watchedTableDuck.fetch(url, { params }, transform));
  };
}

function setWatchedTablePageIndex(index) {
  return { type: SET_WATCHED_TABLE_PAGE_INDEX, payload: { index } };
}

// Selectors
const getWatchedTableIsLoading = (state) =>
  watchedTableDuck.selectors.getData(state)?.isLoading ?? false;
const getWatchedTableResults = (state) =>
  watchedTableDuck.selectors.getData(state)?.data?.data ?? [];

const getWatchedTablePageIndex = (state) =>
  state[STORE_MOUNT_POINT].watchedTablePageIndex ?? 0;
const getWatchedTablePageSize = (state) => 10;
const getWatchedTablePageCount = (state) =>
  watchedTableDuck.selectors.getData(state)?.data?.meta?.totalPages ?? 0;

// Reducer
const partViewDashboardReducer = (
  state = {
    watchedTablePageIndex: 0,
    etaCounts: { packages: {}, orders: {}, parts: {} },
  },
  action,
) => {
  switch (action.type) {
    case SET_WATCHED_TABLE_PAGE_INDEX:
      return { ...state, watchedTablePageIndex: action.payload.index };
    default:
      return state;
  }
};

const PartViewDashboardState = {
  mountPoint: STORE_MOUNT_POINT,
  actionCreators: {
    fetchExceptionList,
    fetchExceptionOrPackageStatusCounts,
    fetchWatchedPackages,
    setWatchedTablePageIndex,
  },
  selectors: {
    getExceptionsListRequestData: exceptionsListFetchDuck.selectors.getData,
    getExceptionCountsRequestData: exceptionCountsFetchDuck.selectors.getData,
    getWatchedTableIsLoading,
    getWatchedTableResults,
    getWatchedTablePageIndex,
    getWatchedTablePageSize,
    getWatchedTablePageCount,
  },
  reducer: chainReducers([
    exceptionsListFetchDuck.reducer,
    exceptionCountsFetchDuck.reducer,
    watchedTableDuck.reducer,
    partViewDashboardReducer,
  ]),
};

export default PartViewDashboardState;
